// extracted by mini-css-extract-plugin
export default {"videosTable":"bvyljm64ZQra31cE8r5w"};